import type { HTMLAttributes, ReactNode } from "react";

export interface ContainerProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  className?: string;
  as?: keyof HTMLElementTagNameMap;
}

export const Container = ({
  children,
  className = "",
  as: Component = "div",
  ...props
}: ContainerProps) => {
  const Comp = Component as any;
  return (
    <Comp
      className={`max-w-[800px] w-full mx-auto px-4 box-border ${className}`.trim()}
      {...props}
    >
      {children}
    </Comp>
  );
};
